import React from "react";
import { useParams } from "react-router-dom";
import { usePermissionGuardRedirect } from "../../../../hooks/usePermissionGuard";
import { GetExamCentresAuditFilters, GetExamCentresAuditTrails } from "../../../../services/ExternalExamServices";
import AuditTrailsTable from "../../../common/AuditTrailsTable";

function ExamCenterAuditTrail() {
  const { id } = useParams();
  const columnsToShow = ["Action Type", "Resource Type", "Resource Name"];

  usePermissionGuardRedirect(['eeecview']);

  return (
    <AuditTrailsTable 
      apiFunction={GetExamCentresAuditTrails}
      filterArrApi={GetExamCentresAuditFilters}
      columnsToShow={columnsToShow}
      exportFileName={"Exam_Center_Audit_Trail"}
      isResourceNameShown={true}
      apiParams={{action_id: id}}
      actionId={id}
      isShowingResourceTypeFilter
    />
  );
}

export default ExamCenterAuditTrail;
